import { Box } from "@mui/material";
import WhiteCardInfo from "../../typographies/WhiteCardInfo";
import BlackCardInfo from "../../typographies/BlackCardInto";

interface Props {
  dark?: boolean;
}

const LatestLabel = ({ dark }: Props) => {
  return (
    <Box sx={{ marginBottom: 0.5, marginTop: 0.5 }}>
      {dark ? (
        <BlackCardInfo text="De senaste 30 dagarna" />
      ) : (
        <WhiteCardInfo text="De senaste 30 dagarna" />
      )}
    </Box>
  );
};

export default LatestLabel;
